<template>
  <div class="tracking-table" v-if="trackings">
    <table class="table">
      <tr>
        <th class="tracking-date">{{$t('statistics.tracking_time')}}</th>
        <th class="tracking-kit">{{$t('statistics.tracking_kit')}}</th>
        <th class="tracking-activity">{{$t('statistics.tracking_activity')}}</th>
        <th class="tracking-kit-activity">{{$t('statistics.kit_and_activity')}}</th>
        <th class="tracking-hint"></th>
      </tr>
      <tr v-for="tracking in trackings" :key="tracking.id" :class="'tracking-list-' + tracking.id">
        <td class="tracking-date">{{date(tracking.time)}}</td>
        <td class="tracking-kit">{{tracking.event_name}}</td>
        <td class="tracking-activity">{{tracking.advertisement_name}} {{$t('models.tracking.specific.' + tracking.name)}} <a v-if="tracking.referrer_url" :href="tracking.referrer_url" target="_blank" class="icon icon-external-link"></a></td>

        <td class="tracking-kit-activity">
          {{tracking.event_name}}<br v-if="tracking.event_name"/>
          {{tracking.advertisement_name}} {{$t('models.tracking.specific.' + tracking.name)}} <a v-if="tracking.referrer_url" :href="tracking.referrer_url" target="_blank" class="icon icon-external-link"></a>
        </td>
        <td class="tracking-hint">
          <div class="hint">
            <i class="icon icon-info trigger"></i>
            <div class="hint-content">
              <p>
                <i class="icon icon-map-pin"></i>
                {{tracking.city}}
              </p>
              <p>
                <i class="icon icon-monitor"></i>
                {{tracking.browser}} | {{tracking.os}}
              </p>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>

export default {
  props: {
    trackings: Array,
    dateFormat: {
      type: String,
      default: "HH:mm"
    },
  },
  methods: {
    date(date){
      return moment(date).format(this.dateFormat)
    },
    leadName(lead){
      if(lead.firstname == '' && lead.lastname == ''){
        return lead.email
      }
      return (lead.firstname + ' ' + lead.lastname).trim()
    }
  }
}
</script>
<style lang="scss" scoped>

.tracking-table{
  margin-bottom: 30px;
  .table{
    table-layout: fixed;
  }
  word-wrap: break-word;
}
.table{
  max-width: 100%;
}
.table th, .table td{
  padding: 10px;
}
.icon{
  text-decoration: none;
  color: #a09898;
  font-size: 16px;
  vertical-align: sub;
  user-select: none;
}
.tracking-date{
  min-width: 12%;
  word-wrap: normal;
  padding-left: 20px !important;
  padding-right: 5px !important;
  @include respond-to("medium") {
    padding-left: 0px !important;
    width: 15%;
  }
}

td.tracking-date {
  font-size: 12px;
}
.tracking-kit-activity{
  display: none;
  @include respond-to("medium") {
    display: table-cell;
    width: 70%;
    vertical-align: middle;
  }
  @media(max-width: 460px) {
    width: 50%;
  }
}
.tracking-activity{
  width: 50%;
  @include respond-to("medium") {
    display: none;
  }

}
.tracking-kit{
  min-width: 150px;
  width: 30%;
  @include respond-to("medium") {
    display: none;
  }
}
.tracking-hint{
  width: 5%;
  .icon{
    font-size: 20px;
  }
  @include respond-to("medium") {
    width: 10%;
  }
  @media(max-width: 460px) {
    display: none;
  }
}
.hint{
  position: relative;
  &:hover{
    .hint-content{
      display: block;
    }
  }
}
.hint-content{
  padding: 10px;
  display: none;
  position: absolute;
  top: 20px;
  right: 0;
  white-space: nowrap;
  min-width: 150px;
  z-index: 2;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.18);
  background: #fff;
  .icon{
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// TrackingTable.vue?73487cf4